module.exports = __webpack_public_path__ + "static/media/led-lasalle-lightbulbs.a24070fe.webp";